import { useCallback } from 'react';
import { useEscapeKey } from './useEscapeKey';
import { GridApi } from '@ag-grid-community/core';
/**
 * Hook that handles Escape key presses for Grid.tsx.
 *
 * Hides popup menus and prevents propagation to parent modal handlers (Modal.js and AuthoringWorkflow.jsx).
 *
 * @param gridApi - The ag-Grid API instance
 * @param gridRefWrapper - React ref to the grid container element
 * @param showAgGridColumnMenu - Whether the column menu is currently visible
 */
export function useGridEscapeKeyHandler(
  gridApi: GridApi | null,
  gridRefWrapper: React.RefObject<HTMLDivElement>,
  showAgGridColumnMenu?: boolean,
) {
  const onKeyup = useCallback(() => {
    gridApi?.hidePopupMenu();
  }, [gridApi]);
  useEscapeKey({
    onKeyup: onKeyup,
    enabled: Boolean(gridApi) && showAgGridColumnMenu,
    eventTarget: gridRefWrapper.current ?? window,
    restoreFocusTarget: '.authoring-modal',
  });
}
